// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"5697b15a","215":"90b726a2","659":"219a71c5","807":"7933724f","881":"76cd9d22","937":"8cb1e433","956":"5697b15a"}[chunkId] + ".chunk.css";
};